import { ScoreGaugeProps } from '@/types/components'
import { cn } from '@/utils/cn'

const BAND_COLORS = {
  'A+': '#10b981', // green-500
  'A': '#10b981',
  'B+': '#3b82f6', // blue-500
  'B': '#3b82f6',
  'C+': '#f59e0b', // amber-500
  'C': '#f97316', // orange-500
  'D': '#ef4444'  // red-500
}

export function ScoreGauge({
  score,
  band,
  size = 120,
  thickness = 8,
  showLabels = true,
  animated = true,
  className
}: ScoreGaugeProps) {
  const radius = (size - thickness) / 2
  const circumference = 2 * Math.PI * radius
  const strokeDasharray = circumference
  const strokeDashoffset = circumference - (score / 100) * circumference
  
  const color = BAND_COLORS[band]
  const center = size / 2

  return (
    <div className={cn('relative inline-flex items-center justify-center', className)}>
      <svg
        width={size}
        height={size}
        className="transform -rotate-90"
      >
        {/* Background circle */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          stroke="currentColor"
          strokeWidth={thickness}
          fill="none"
          className="text-gray-200 dark:text-gray-700"
        />
        
        {/* Progress circle */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          stroke={color}
          strokeWidth={thickness}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={strokeDasharray}
          strokeDashoffset={strokeDashoffset}
          className={animated ? 'transition-all duration-1000 ease-out' : ''}
          style={{
            transformOrigin: `${center}px ${center}px`
          }}
        />
      </svg>
      
      {/* Center content */}
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="text-2xl font-bold text-gray-900 dark:text-white">
          {score.toFixed(0)}
        </div>
        {showLabels && (
          <div 
            className="text-sm font-medium"
            style={{ color }}
          >
            {band}
          </div>
        )}
      </div>
    </div>
  )
}